import React from 'react';
import {AntdFormValues} from "../../helpers/antdFormValidations";
import FormItem from "antd/lib/form/FormItem";
import {Nullable} from "../../models/Common";

export type ConditionalFormSectionMap<FormValues extends AntdFormValues, Field extends keyof FormValues> = Map<FormValues[Field] | FormValues[Field][], React.ReactNode>;

type ConditionalFormSectionProps<FormValues extends AntdFormValues, Field extends keyof FormValues = string> = {
  field: Field;
  map: ConditionalFormSectionMap<FormValues, Field>;
};

const ConditionalFormSection = <FormValues extends AntdFormValues, Field extends keyof FormValues>({ field, map }: ConditionalFormSectionProps<FormValues, Field>) => {
  const getElement = (value: FormValues[Field]): React.ReactNode => {
    const exactMatch: Nullable<React.ReactNode> = map.get(value);
    if(exactMatch) {
      return exactMatch;
    }
    const arrayKeyMatch: Nullable<FormValues[Field][]> = (Array.from(map.keys())
      .filter(key => Array.isArray(key)) as FormValues[Field][][])
      .find(key => key.includes(value));
    return arrayKeyMatch ? map.get(arrayKeyMatch) : null;
  };

  return (
    <FormItem<FormValues> style={{ margin: 0 }} shouldUpdate={(prev, curr): boolean => prev[field] !== curr[field]}>
      {({ getFieldValue }) => (getElement(getFieldValue(field as string)))}
    </FormItem>
  );
};

export default ConditionalFormSection;